module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"accept":"Применить","reset":"Сброс"}}')
  delete Component.options._Ctor
}
